<div
  *ngIf="enabled && chatController"
  class="ai-chat-widget"
  [class.ai-chat-widget--hidden]="!isWidgetVisible"
  [class.ai-chat-widget--animate-open]="shouldAnimateOpen && isWidgetVisible"
  [class.ai-chat-widget--animate-close]="shouldAnimateClose"
  [style.left.px]="x"
  [style.top.px]="y"
  [style.width.px]="widgetWidth"
  [style.height.px]="widgetHeight"
  (animationend)="$event.target === $event.currentTarget && onWidgetAnimationEnd()"
  (dragover)="chat.onDragOver($event)"
  (dragleave)="chat.onDragLeave($event)"
  (drop)="chat.onDrop($event)"
>
  <chat-component
    #chat
    [chatController]="chatController"
    [restoreScrollTop]="restoreScrollTop"
    (closed)="toggleChat()"
    (activeSessionChange)="onActiveSessionChange($event)"
    (scrollPositionChange)="onScrollPositionChange($event)"
  ></chat-component>
  <div
    class="ai-chat-drag-handle"
    (mousedown)="onDragStart($event)"
  ></div>
  <div
    class="ai-chat-resize-handle ai-chat-resize-handle--nw"
    (mousedown)="onResizeStart($event, 'nw')"
  ></div>
  <div
    class="ai-chat-resize-handle ai-chat-resize-handle--ne"
    (mousedown)="onResizeStart($event, 'ne')"
  ></div>
  <div
    class="ai-chat-resize-handle ai-chat-resize-handle--sw"
    (mousedown)="onResizeStart($event, 'sw')"
  ></div>
  <div
    class="ai-chat-resize-handle ai-chat-resize-handle--se"
    (mousedown)="onResizeStart($event, 'se')"
  ></div>
</div>
